var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0834 14.3667C12.9052 14.3667 11.95 15.3218 11.95 16.5V53.8333C11.95 55.0115 12.9052 55.9667 14.0834 55.9667H51.4167C52.5949 55.9667 53.55 55.0115 53.55 53.8333V16.5C53.55 15.3218 52.5949 14.3667 51.4167 14.3667H14.0834ZM7.55005 16.5C7.55005 11.7872 9.37055 9.96667 14.0834 9.96667H51.4167C56.1295 9.96667 57.95 11.7872 57.95 16.5V53.8333C57.95 58.5462 56.1295 60.3667 51.4167 60.3667H14.0834C9.37055 60.3667 7.55005 58.5462 7.55005 53.8333V16.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.75 4.5C45.4069 4.5 46.75 5.67525 46.75 7.125V15.875C46.75 17.3247 45.4069 18.5 43.75 18.5C42.0931 18.5 40.75 17.3247 40.75 15.875V7.125C40.75 5.67525 42.0931 4.5 43.75 4.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 4.5C23.4069 4.5 24.75 5.67525 24.75 7.125V15.875C24.75 17.3247 23.4069 18.5 21.75 18.5C20.0931 18.5 18.75 17.3247 18.75 15.875V7.125C18.75 5.67525 20.0931 4.5 21.75 4.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 26.5C8.75 25.3954 10.0141 24.5 11.5735 24.5H53.9265C55.4859 24.5 56.75 25.3954 56.75 26.5C56.75 27.6046 55.4859 28.5 53.9265 28.5H11.5735C10.0141 28.5 8.75 27.6046 8.75 26.5Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpire);
export default __webpack_public_path__ + "static/media/expire.3476765727e86803930b9e8dab088391.svg";
export { ForwardRef as ReactComponent };